import $ from 'jquery';
// import init from '../init';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	// no orphans in the title.
	// $(window).on('load', function(){
	// 	$('.heading_title').each(function() {
	// 		$(this).html($(this).html().replace(/\s([^\s<]+)\s*$/,'&nbsp;$1'));
	// 	});
	// });

	// page headers

	if ($('.vehicles_header_selector').length) {
		let selector = $('.vehicles_header_selector select');
		let url = window.location.origin + '/vehicles/';
		selector.on('change', function(){
			let val = $(this).val();
			window.location.href = url + val;
		});
	}

	let show = $('.show-more');
	if(show.length) {
		show.click(function(){
			let _this = $(this);
			let parent = _this.closest('.vehicle_content_stats');
			let span = _this.find('> span');
			if (_this.hasClass('-reverse')) {
				parent.find('.extra').slideUp();
				_this.removeClass('-reverse');
				span.html('Show more');
			} else {
				parent.find('.extra').slideDown();
				_this.addClass('-reverse');
				span.html('Show less');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js